import { get, put, post } from '../Services/http';
import { catchError } from './Error.action';
import {
  CART_LOAD_ERROR,
  CART_RECEIVE,
  CART_SHOW_INFO,
  CART_SHOW_MINI_CART,
  CART_UPDATE_ADDITIONAL_INFO,
} from '../constants';
import { dataLayerRemoveFromCart } from '../Services/Gtm.service';

export const load = () => (dispatch, getState) => {
  return get('/api/cart')
    .then((response) => response.json())
    .then((cart) => {
      dispatch(receive(cart));
    })
    .catch((ex) => dispatch(catchError(ex, (error) => loadError(error))));
};

export const loadError = (error) => ({
  type: CART_LOAD_ERROR,
  payload: {
    error,
  },
});

export const receive = (cart) => ({
  type: CART_RECEIVE,
  payload: cart,
});

export const toggle = () => (dispatch, getState) => {
  dispatch(show(!getState().cart.showInfo));
};

const show = (visible) => ({
  type: CART_SHOW_INFO,
  payload: {
    showInfo: visible,
  },
});

export const setShowMiniCart = (showMiniCart) => ({
  type: CART_SHOW_MINI_CART,
  payload: {
    showMiniCart,
  },
});

export const update = (articleNumber, quantity, rowSystemId, addTestCertificate, abortController = null) => (dispatch, getState) => {
  const existingRow = getState().cart.orderRows.find(
    (r) => r.rowSystemId == rowSystemId
  );
  return put(`/api/cart/update`, { articleNumber, quantity, rowSystemId, addTestCertificate }, abortController)
    .then((response) => response.json())
    .then((cart) => {
      dispatch(receive(cart));
    })
    .then(() =>
      // Refresh from /api/cart so the Bendix sub-box broken-box pricing override
      // shows up in GrandTotal. The override is applied to the cart session AFTER
      // Litium's CalculatePaymentsAsync (any earlier and Litium recomputes UnitPrice
      // back to full-box), which means the Update response itself still contains the
      // pre-override total. A follow-up GET reads the session fresh and returns the
      // adjusted total without a page refresh.
      dispatch(load())
    )
    .then(
      () => existingRow && quantity <= 0 && onRemoveFromCart(existingRow)
    )
    .catch((ex) => {
      dispatch(catchError(ex, (error) => loadError(error)));
      throw ex;
    });
};

export const add = ({
  articleNumber,
  quantity = 1,
  nodeIdToShowNotification = null,
  notificationMessage = null,
  hash = '',
}) => {
  return (dispatch) => {
    if (!quantity || isNaN(quantity) || parseInt(quantity) <= 0) {
      return;
    }

    return post('/api/cart/add', {
      articleNumber,
      quantity: parseInt(quantity),
    })
      .then((response) => response.json())
      .then((cart) => {
        dispatch(receive(cart));
        nodeIdToShowNotification &&
          dispatch(
            showNotification(
              nodeIdToShowNotification,
              notificationMessage,
              hash
            )
          );
      })
      .catch((ex) => dispatch(catchError(ex, (error) => loadError(error))));
  };
};

export const addOrderCertificateFee = (addOrderCertificate) => (dispatch) => {
  return put('/api/cart/addOrderCertificate', { addOrderCertificate })
    .then((response) => response.json())
    .then((cart) => {
      dispatch(receive(cart));
    })
    .catch((error) => {
      dispatch(catchError(error, (err) => loadError(err)));
    });
};


export const clear = (abortController = null) => (dispatch) => {
  return post(`/api/cart/clear`, null, abortController)
    .then((response) => response.json())
    .then((cart) => dispatch(receive(cart)))
    .catch((ex) => dispatch(catchError(ex, (error) => loadError(error))));
};

export const updateAdditionalInfo = (orderRows) => ({
  type: CART_UPDATE_ADDITIONAL_INFO,
  payload: {
    orderRows,
  }
})

const onRemoveFromCart = (orderRow) => {
  dataLayerRemoveFromCart([orderRow.gtmEcommerceItem]);
};
